import Template from "./template";
import paper from "paper";
import ComponentPort from "../core/componentPort";
import { LogicalLayerType  } from "../core/init";

export default class Port extends Template {
    constructor() {
        super();
    }

    __setupDefinitions(): void  {
        this.__unique = {
            position: "Point"
        };

        this.__heritable = {
            componentSpacing: "Float",
            portRadius: "Float",
            depth: "Float"
        };

        this.__defaults = {
            componentSpacing: 2000,
            portRadius: 1000,
            depth: 1.1 * 1000
        };

        this.__units = {
            componentSpacing: "μm",
            portRadius: "μm",
            depth: "μm"
        };

        this.__minimum = {
            componentSpacing: 0,
            portRadius: 0.8 * 10,
            depth: 10
        };

        this.__maximum = {
            componentSpacing: 10000,
            portRadius: 3000,
            depth: 1200
        };

        this.__placementTool = "componentPositionTool";

        this.__toolParams = {
            position: "position"
        };

        this.__featureParams = {
            componentSpacing: "componentSpacing",
            position: "position",
            portRadius: "portRadius"
        };

        this.__targetParams = {
            componentSpacing: "componentSpacing",
            portRadius: "portRadius"
        };

        this.__renderKeys = ["FLOW"];

        this.__mint = "PORT";

        this.__zOffsetKeys = {
            FLOW: "depth"
        };

        this.__substrateOffset = {
            FLOW: "0"
        };
    }

    render2D(params: { [k: string]: any }, key: string) {
        // Regardless of the key...
        const position = params.position;
        const radius = params.portRadius;
        const color1 = params.color;
        const pos = new paper.Point(position[0], position[1]);
        const outerCircle = new paper.Path.Circle(pos, radius);
        outerCircle.fillColor = color1;
        return outerCircle;
    }

    render2DTarget(key: string | null, params: { [k: string]: any }) {
        if (key === null) {
            key = this.__renderKeys[0];
        }
        const render = this.render2D(params, key);
        render.fillColor!.alpha = 0.5;
        return render;
    }

    drawsAtPositionCenter(): boolean {
        return true;
    }

    getPorts(params: { [k: string]: any }) {
        const ports = [];
        // Geometric center; MINT pad sides 1–4 are compiled in fluigi, not drawn here.
        ports.push(new ComponentPort(0, 0, "1", LogicalLayerType.FLOW));
        return ports;
    }
}
